<app-modal class="operation-type-create-modal">
    <ng-container modal-header>
        <h5 class="modal-title" [innerText]="label | translate"></h5>
    </ng-container>
    <div class="content" modal-body>
        <div class="left">
            <app-tool-scan-tree
                [isMaterial]="false"
                [loading]="loading"
                labelText="{{'lineSetter.pending-tool-requests.table.details-modal.selectedTools'| translate}}"
                class="toolScanner"
                [items]="pendingToolRequest.requestTools"
            ></app-tool-scan-tree>
        </div>
        <div class="right">
            <section class="tool-request-details">
                <h5>{{ 'lineSetter.pending-tool-requests.table.details-modal.detailsTitle' | translate }}</h5>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.name' | translate}}"
                    [value]="pendingToolRequest?.name" style="width: 200px"></app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.status' | translate}}"
                    [value]="pendingToolRequest?.status" style="width: 200px"></app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.createdDate' | translate}}"
                    [value]="pendingToolRequest?.createdDate" style="width: 200px"></app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.createdBy' | translate}}"
                    [value]="pendingToolRequest?.createdBy?.fullName"
                    style="width: 200px"></app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.assignedTo' | translate}}"
                    [value]="pendingToolRequest?.assignedTo?.fullName"
                    style="width: 200px"></app-display-label>
            </section>
            <section *ngIf="shouldShowClosedInfo()" class="tool-request-details">
                <h5>{{ 'lineSetter.pending-tool-requests.table.details-modal.closeInfoTitle.' + pendingToolRequest.status | translate }}</h5>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.closeReason' | translate}}"
                    [value]="getCloseReason()" style="width: 200px"></app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.closedDate.' + pendingToolRequest.status | translate}}"
                    [value]="pendingToolRequest?.closedDate" style="width: 200px"></app-display-label>
                <app-display-label
                    [stretch]="true"
                    label="{{'lineSetter.pending-tool-requests.table.details-modal.closedBy.'+ pendingToolRequest.status | translate}}"
                    [value]="pendingToolRequest?.assignedTo?.fullName"
                    style="width: 200px">
                </app-display-label>
            </section>
        </div>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    class="waves-effect btn-flat"
                    (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button *ngIf="computeCanRenderClose(pendingToolRequest)"
                    type="danger"
                    class="btn btn-danger"
                    (click)="clickCloseToolRequest()">
            {{ 'generic.buttons.cancel' | translate }}
        </app-button>
    </div>
</app-modal>
<app-confirmation-modal (confirmEvent)="onConfirmOrder($event)"
                        [title]="'lineSetter.toolRequest.pages.cancelToolRequest.popupTitle' | translate"
                        [displayReasonLabel]="'lineSetter.toolRequest.pages.cancelToolRequest.cancelReason' | translate"
                        [displayReasonPlaceholder]="'lineSetter.toolRequest.pages.cancelToolRequest.reasonMessage' | translate"
                        [reasonMandatory]="true"
                        [confirmWithReason]="true"
                        [isConfirmationInProgress]="isConfirmationInProgress">
</app-confirmation-modal>
